var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classes},[_vm._v("\n    "+_vm._s(_vm.data.label)+"\n    "),(_vm.showArrow)?_c('i',{staticClass:"ivu-icon ivu-icon-ios-arrow-forward"}):_vm._e(),_vm._v(" "),(_vm.showLoading)?_c('i',{staticClass:"ivu-icon ivu-icon-ios-loading ivu-load-loop"}):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/cascader/casitem.vue